import React, { useEffect, useState } from "react";
import { Field, Section, fieldClass, buttonClass, errorText } from "./shared";

export default function CampaignInvoices({ filters, value, onChange, request, filialId, readonly }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [revision, setRevision] = useState(0);
  const filtersKey = JSON.stringify(filters);
  useEffect(() => {
    if (!filters.mode || readonly) {
      setLoading(false);
      setError("");
      if (!filters.mode) setRows([]);
      return undefined;
    }
    const abort = new AbortController();
    setLoading(true);
    setRows([]);
    setError("");
    request("post", "/messaging/campaigns/variable-records", { audience_filters: JSON.parse(filtersKey) }, abort.signal)
      .then(({ data }) => {
        if (abort.signal.aborted) return;
        if (Number(data.filial_id) !== Number(filialId)) throw new Error("Location changed");
        setRows(data.rows || []);
      })
      .catch(failure => { if (!abort.signal.aborted) setError(errorText(failure)); })
      .finally(() => { if (!abort.signal.aborted) setLoading(false); });
    return () => abort.abort();
  }, [filtersKey, filters.mode, request, filialId, readonly, revision]);

  return <Section title="Invoice for each student">
    <p className="text-sm">Choose the invoice that supplies the financial variables for each message. Save the draft after choosing invoices.</p>
    {!filters.mode && <p className="text-xs text-gray-600">Select the recipients first.</p>}
    {readonly && <p className="text-xs text-gray-600">Invoice selections are read-only for this campaign.</p>}
    {loading && <p role="status" className="text-xs">Loading invoices…</p>}
    {error && <div role="alert" className="text-sm text-red-700">{error}<button type="button" className={buttonClass} onClick={() => setRevision(current => current + 1)}>Refresh invoices</button></div>}
    {!loading && !error && filters.mode && !readonly && !rows.length && <p className="text-xs">No students match the current audience.</p>}
    {rows.map(row => {
      const selected = value?.receivable_ids?.[row.student_id] || "";
      const available = row.invoices.some(invoice => invoice.id === selected);
      return <div key={row.student_id} className="flex flex-col gap-1">
        <Field label={row.student_name + " · " + row.registration_number}>
          <select className={fieldClass} disabled={readonly || loading || !row.invoices.length} value={selected} onChange={event => {
            const receivable_ids = { ...(value?.receivable_ids || {}) };
            if (event.target.value) receivable_ids[row.student_id] = event.target.value;
            else delete receivable_ids[row.student_id];
            onChange({ receivable_ids });
          }}>
            <option value="">Select an invoice</option>
            {selected && !available && <option value={selected}>Previously selected invoice is unavailable</option>}
            {row.invoices.map(invoice => <option key={invoice.id} value={invoice.id}>#{invoice.invoice_number} · Due {invoice.due_date} · Balance {invoice.balance}</option>)}
          </select>
        </Field>
        {!row.invoices.length && <p className="text-xs text-red-700">This student has no invoice matching the campaign filters.</p>}
        {!!row.invoices.length && (!selected || !available) && <p className="text-xs text-orange-700">Choose an available invoice before reviewing the campaign.</p>}
      </div>;
    })}
  </Section>;
}
